import React, { useContext } from 'react';
import { Upload, Row, Col, Typography, Card, Button, theme, Grid } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { UploadOutlined } from '@ant-design/icons';
import _ from 'lodash';

//Helpers
import AssetHelper from '../../helpers/asset';
import GeneralHelper from '../../helpers/general';
import { MessageContext } from '../../layouts/NavigationLayout';

const { Text } = Typography;
const { useToken } = theme;
const { useBreakpoint } = Grid;

const CustomFileUpload = ({ style, attachment, setAttachment, customFileName, setIsInitialLoad }) => {

	const { token } = useToken();
	const screens = useBreakpoint();
	const messageApi = useContext(MessageContext);

	const { colorLink } = token;
	const textLimit = screens.xs ? 10 : 30;

	//Start of functions
	const uploadProps = {
		name: 'file',
		action: AssetHelper.getActionUrl(),
		headers: AssetHelper.getHeader(),
		accept: '.pdf',
		showUploadList: false,
		beforeUpload: (file, fileList) => {
			if (file.size > AssetHelper.getMaxSize()) {
				messageApi.open({
					type: 'error',
					content: `${file.name} ${AssetHelper.getMaxSizeMsg()}`,
					duration: 2.5
				});
				file.status = 'error';
				return false || Upload.LIST_IGNORE;
			}
			const fileName = customFileName ? `${file.name}&dl_file_name=${customFileName}` : file.name;
			const newFile = new File([file], fileName, { type: file.type });
			return newFile;
		},
		onChange: (info) => {
			const fileName = info.file.name.split('&dl_file_name')[0] || '';
			if (info.file.status === 'done') {
				messageApi.open({
					type: 'success',
					content: `${fileName} file uploaded successfully`,
					duration: 2.5
				});
			}

			let file = info.file;
			if (file.response) {
				file.url = AssetHelper.getDownloadUrl(file.response.data.asset._id);
				file.asset_id = file.response.data.asset._id;
				file.name = file.response.data.asset.file_name;
			}
			if(file.response && file.status === 'error'){
				messageApi.open({
					type: 'error',
					content: `${fileName} file upload failed.`,
					duration: 2.5
				});
			}
			file.status !== 'error' && setAttachment(file);
			setIsInitialLoad(false);
		}
	};
	return(
		<Row gutter={6}>
			<Col
				xxl={18}
				xl={18}
				lg={18}
				md={18}
				sm={24}
				xs={24}
				xxs={24}
			>
				<Card
					style={{
						...style,
						height: 34,
						marginTop: 9,
						padding: 0,
						flexGrow: 1
					}}
				>
					<Row
						gutter={8}
						justify="space-between"
						style={{ position: 'relative', top: -19, marginLeft: -18, marginRight: -25 }}
					>
						<Col 
							xxl={22}
							xl={22}
							lg={22}
							md={22}
							sm={22}
							xs={21}
						>
							{!attachment && <Text style={{ color: '#D4D4D4' }}>Select File</Text>}
							{attachment &&
							<>
								{attachment.status === 'done' ? 
									<a
										href={AssetHelper.getDownloadUrl(attachment.asset_id)}
										target="_blank"
										rel="noreferrer"
									>
										<Text
											style={{ color: '#0088FF' }}
											underline={attachment.status === 'done'}
										>
											{GeneralHelper.truncateFileName(attachment.name, textLimit, 'pdf' )}
										</Text>
									</a>
									:
									<Text style={{ color: attachment.status === 'uploading' ? '' : '#D4D4D4' }}>
										{attachment.status === 'uploading' ? 'Uploading file...' : 'Select File'}
									</Text>
								}
							</>
							}
						</Col>
						<Col 
							xxl={2}
							xl={2}
							lg={2}
							md={2}
							sm={2}
							xs={3}
						>
							{ _.isEmpty(attachment) || attachment?.status === 'uploading' ?
								null :
								<FontAwesomeIcon
									icon={faTimes}
									style={{
										cursor: 'pointer',
										color: '#D4D4D4',
										marginRight: 2
									}}
									onClick={() => {
										setAttachment(null);
										setIsInitialLoad(false);
									}}
								/>
							}
						</Col>
					</Row>
				</Card>
			</Col>
			<Col 
				xxl={6}
				xl={6}
				lg={6}
				md={6}
				sm={24}
				xs={24}
				xxs={24}
			>
				<Upload
					{...uploadProps}
					style={{ width: '100%' }}
				>
					<Button
						icon={
							<UploadOutlined style={{ marginRight: 5, color: colorLink }}/>
						}
						style={{ 
							width: '100%',
							borderColor: colorLink,
							marginTop: 10
						}}
					>
						<Text style={{ color: '#0088FF' }}>Select File</Text>
					</Button>
				</Upload>
			</Col>
		</Row>
	);
};
export default CustomFileUpload;